// extracted by mini-css-extract-plugin
export default {"info":"employeelist_info__k-s3N","ownerinfo":"employeelist_ownerinfo__F8gk3","box":"employeelist_box__zG9e4"};